// Styles partagés de la gestion des utilisateurs (DO-208) — même charte que les
// autres pages (ConnectionAttemptsPage, Layout) : styles inline, pas de CSS central.

export const ROLES = {
  ADMIN: ['Administrateur', '#e3e6f3', '#232853'],
  MANAGER: ['Manager', '#e3edf9', '#005cc5'],
  PUSH_AGENT: ['Robot', '#fff4e0', '#955d00'],
};

export const formatDateTime = v => (v ? new Date(v).toLocaleString('fr-FR') : '—');

export { pill as badge } from '../pill';

export const td = { padding: '0.85rem 1rem', color: '#444444', verticalAlign: 'middle' };
export const th = { padding: '0.75rem 1rem', textAlign: 'left' };
export const theadRow = { color: '#8a8f99', fontSize: '0.8rem', textTransform: 'uppercase', borderBottom: '1px solid #cdcdcd' };
export const muted = { color: '#b0b5bf', fontStyle: 'italic' };
export const linkBtn = { background: 'none', border: 'none', padding: 0, margin: 0, color: '#232853', cursor: 'pointer', font: 'inherit', lineHeight: 'inherit', textAlign: 'left' };
export const label = { display: 'block', color: '#6b7280', fontSize: '0.8rem', marginBottom: '4px' };
export const input = { width: '100%', padding: '0.6rem', background: '#f5f5f5', border: '1px solid #cdcdcd', color: '#444444', borderRadius: '6px', boxSizing: 'border-box', font: 'inherit' };
export const error = { color: '#c62828', fontSize: '0.85rem', marginTop: '0.75rem' };
export const success = { color: '#1a7f37', fontSize: '0.85rem', marginTop: '0.75rem' };
